import { cn } from "@/lib/utils";

export interface DividerV2Props {
  orientation?: "horizontal" | "vertical";
  label?: string;
  className?: string;
}

export function DividerV2({
  orientation = "horizontal",
  label,
  className,
}: DividerV2Props) {
  if (orientation === "vertical") {
    return (
      <div
        role="separator"
        aria-orientation="vertical"
        className={cn(
          "inline-block w-px self-stretch bg-[var(--v2-border)]",
          className
        )}
      />
    );
  }

  if (label) {
    return (
      <div
        role="separator"
        aria-orientation="horizontal"
        className={cn("flex items-center gap-3", className)}
      >
        <span
          className="h-px flex-1 bg-[var(--v2-border)]"
          aria-hidden="true"
        />
        <span className="shrink-0 text-xs font-medium text-[var(--v2-text-muted)]">
          {label}
        </span>
        <span
          className="h-px flex-1 bg-[var(--v2-border)]"
          aria-hidden="true"
        />
      </div>
    );
  }

  return (
    <hr
      role="separator"
      aria-orientation="horizontal"
      className={cn("border-0 border-t border-[var(--v2-border)]", className)}
    />
  );
}
